import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './core/guards/login.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'terms',
    pathMatch: 'full',
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/terms/terms.module').then((m) => m.TermsPageModule),
    canActivate: [LoginGuard],
  },

  {
    path: 'about-page',
    loadChildren: () =>
      import('./pages/about-page/about-page.module').then((m) => m.AboutPagePageModule),
  },
  {
    path: 'language',
    loadChildren: () =>
      import('./pages/languages/languages.module').then((m) => m.LanguagesPageModule),
  },
  {
    path: 'redirect/:provider',
    loadChildren: () =>
      import('./pages/redirect/redirect.module').then((m) => m.RedirectPageModule),
  },
  {
    path: 'redirect/:provider/:platform',
    loadChildren: () =>
      import('./pages/redirect/redirect.module').then((m) => m.RedirectPageModule),
  },
  {
    path: 'add-value/:provider',
    loadChildren: () =>
      import('./pages/redirect/redirect.module').then((m) => m.RedirectPageModule),
  },
  {
    path: 'qrscan-mobile',
    loadChildren: () =>
      import('./pages/qrscan-mobile/qrscan-mobile.module').then((m) => m.QrscanMobilePageModule),
  },
  {
    path: 'accounts',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/accounts/accounts.module').then((m) => m.AccountsPageModule),
      },
      {
        path: 'add',
        loadChildren: () =>
          import('./pages/add-account/add-account.module').then((m) => m.AddAccountPageModule),
      },
    ],
  },

  {
    path: 'languages',
    loadChildren: () =>
      import('./pages/languages/languages.module').then((m) => m.LanguagesPageModule),
  },
  {
    path: 'balance',
    children: [
      {
        path: 'view',
        loadChildren: () =>
          import('./pages/view-balance/view-balance.module').then((m) => m.ViewBalancePageModule),
      },
      {
        path: 'add',
        loadChildren: () =>
          import('./pages/add-balance/add-balance.module').then((m) => m.AddBalancePageModule),
      },
    ],
  },
  {
    path: 'select-account',
    loadChildren: () =>
      import('./pages/select-account/select-account.module').then((m) => m.SelectAccountPageModule),
  },
  {
    path: 'blank',
    loadChildren: () => import('./pages/blank/blank.module').then( m => m.BlankPageModule)
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
